module.exports = __webpack_public_path__ + "media/images/athletes/1684-b7dfbe81fc04f5aa7b6d74af0af94c73.png";